var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"day"},[_c('p',{staticClass:"h3 font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.dayString)+"\n        ")]),_c('p',{staticClass:"h4"},[_vm._v("\n            "+_vm._s(_vm.timeString)+"\n        ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }